import { Entity } from "typeorm";
import { CitationBlockType } from "./citation-block-type.enum";

@Entity()
export class CitationBlock {
    constructor (public id: string, public name: string, public type: CitationBlockType) {
    }
}
